<template lang="pug">
  div
    TextBox(
      :error-messages="errors.first_name",
      :label="$t('form.user.profile.first_name')",
      :value.sync="payload.first_name"
      @update:value="clearError('first_name')",
    )

    TextBox(
      :error-messages="errors.last_name",
      :label="$t('form.user.profile.last_name')",
      :required="false",
      :value.sync="payload.last_name"
      @update:value="clearError('last_name')",
    )

    TextBox(
      :error-messages="errors.email",
      :label="$t('form.user.profile.email')",
      :required="false",
      :value.sync="payload.email"
      @update:value="clearError('email')",
    )

    Password(
      v-if="!isEdit && isSuperadmin",
      :error-messages="errors.password",
      :label="$t('form.user.profile.password')",
      :value.sync="payload.password",
      @update:value="clearError('password')",
    )

    RadioGroup(
      v-if="isSuperadmin",
      :error-messages="errors.role",
      :label="$t('form.user.profile.role')",
      :list="roles",
      :value.sync="payload.role",
      @update:value="clearError('role');",
    )

    v-select(
      required,
      v-model="payload.shop_id",
      item-text="name",
      item-value="id",
      :error-messages="errors.shop_id",
      :items="shops"
      :label="$t('form.user.profile.shop')",
      :rules="[v => !!v || 'Shop is required']",
      @input="updateShop",
      @update:value="clearError('shop_id')",
    )
      template(v-slot:selection="{ item }")
        div {{ item.name }} - {{ item.country }}

      template(v-slot:item="{ item }")
        div {{ item.name }} - {{ item.country }}

    Phone(
      :country="country",
      :error-messages="errors.mobile",
      :extension-label="$t('form.user.profile.extension')",
      :label="$t('form.user.profile.mobile_number')",
      :value.sync="payload.mobile",
      @update:value="clearError('mobile')",
    )

    CheckboxPicker(
      :title="$t('form.user.profile.medical_condition')",
      :items="medicalConditions",
      :value.sync="medical_conditions",
      :error-messages="errors.medical_conditions",
      @update:value="clearError('medical_conditions')",
    )

    CheckboxPicker(
      :title="$t('form.user.profile.scalp_condition')",
      :items="scalpConditions",
      :value.sync="scalp_conditions",
      :error-messages="errors.scalp_conditions",
      @update:value="clearError('scalp_conditions')",
    )

    v-row(no-gutters)
      .flex-grow-1
      v-btn.mt-4(
        color="primary",
        :disabled="hasError || !valid",
        :ripple="false",
        :loading="isLoading",
        @click="submit",
      ) {{ $t(`form.user.profile.${ isEdit ? 'update': 'create'}`) }}
</template>

<script>
import { mergeRight, pick, pluck } from 'ramda';
import { mapGetters } from 'vuex';
import { formHelper } from '@/config/mixins';
import { addExtensionCode } from '@/utils/helper';
import { roles } from '@/constant';
import CheckboxPicker from '@/components/forms/inputs/CheckboxPicker.vue';
import TermsAndConditions from '@/components/forms/TermsAndConditions.vue';

export default {
  components: {
    CheckboxPicker,
    TermsAndConditions,
  },

  mixins: [formHelper],

  data() {
    return {
      medical_conditions: [],
      scalp_conditions: [],
      country: 'Singapore',
      roles,
    };
  },

  computed: {
    ...mapGetters({
      medicalConditions: 'medicalCondition/activeItems',
      scalpConditions: 'scalpCondition/activeItems',
      shops: 'shop/items',
      user: 'user/user',
    }),
  },

  created() {
    if (this.$route.name === 'createUser') {
      this.payload = this.model;
      if (this.isAdmin) {
        this.payload.shop_id = this.authUser.shop_id;
        this.updateShop(this.authUser.shop_id);
      }
    } else {
      this.payload = this.user;
      this.medical_conditions = pluck('id', this.user.medical_conditions);
      this.scalp_conditions = pluck('id', this.user.scalp_conditions);
      this.updateShop(this.payload.shop_id);
    }
  },

  methods: {
    updateShop(shopId) {
      this.country = this.shops.find(shop => shop.id === shopId).country;
    },

    showTermsAndConditions(openFn) {
      if (this.validate()) {
        openFn();
      }
    },

    submit() {
      if (this.validate()) {
        const payload = mergeRight(this.payload, {
          mobile: addExtensionCode(this.country, this.payload.mobile),
          medical_conditions: this.medical_conditions,
          scalp_conditions: this.scalp_conditions,
        });

        const action = this.isEdit ? 'update' : 'create';

        this.$store
          .dispatch(
            `user/${action}`,
            pick(
              [
                'id',
                'creator_id',
                'email',
                'first_name',
                'last_name',
                'password',
                'mobile',
                'role',
                'shop_id',
                'medical_conditions',
                'scalp_conditions',
              ],
              payload,
            ),
            {
              root: true,
            },
          )
          .then(() => this.$router.push({ name: 'users' }))
          .catch(this.setError);
      }
    },
  },
};
</script>
